import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=0eb61a59&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=0eb61a59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb61a59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb61a59')) {
      api.createRecord('0eb61a59', component.options)
    } else {
      api.reload('0eb61a59', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=0eb61a59&scoped=true&", function () {
      api.rerender('0eb61a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/comp/DocBox.vue"
export default component.exports